'use client'
import { forwardRef, HTMLAttributes, PropsWithChildren } from 'react'
import { SplideSlide } from '@splidejs/react-splide'
import { clsx } from 'clsx'

export type CarouselItemProps = PropsWithChildren<HTMLAttributes<HTMLLIElement>>

export const CarouselItem = forwardRef<HTMLLIElement, CarouselItemProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <SplideSlide ref={ref} className={clsx('', className)} {...props}>
        {children}
      </SplideSlide>
    )
  },
)
